import script from "./TutorTeachingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorTeachingForm.vue?vue&type=script&setup=true&lang=js"

import "./TutorTeachingForm.vue?vue&type=style&index=0&id=6130338c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6130338c"]])

export default __exports__